import * as React from 'react';
import classnames from 'classnames';
import { loadReviewSnippet } from '../../ReviewsContext/actions.js';
import { useReviewsContext } from '../../ReviewsContext/ReviewsContext.js';
import { REVIEW_SNIPPET_ID } from '../../ReviewsContext/constants.js';
import { ReviewSnippetSkeleton } from './components/ReviewSnippetSkeleton/ReviewSnippetSkeleton.js';

const ReviewSnippet = ({ productId , variantId , className  })=>{
    const { enabled , dispatch , reviewCount , hasError  } = useReviewsContext();
    React.useEffect(()=>{
        if (enabled && productId) {
            dispatch(loadReviewSnippet({
                id: REVIEW_SNIPPET_ID,
                productId,
                variantId
            }));
        }
    }, [
        enabled,
        productId,
        variantId,
        dispatch
    ]);
    if (!enabled || hasError) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('review-snippet', className),
        "data-t": "review-snippet"
    }, reviewCount === null && /*#__PURE__*/ React.createElement(ReviewSnippetSkeleton, null), /*#__PURE__*/ React.createElement("div", {
        id: REVIEW_SNIPPET_ID,
        className: classnames('review-snippet__container', {
            'review-snippet__container--hidden': reviewCount === null
        })
    }));
};

export { ReviewSnippet as default };
//# sourceMappingURL=ReviewSnippet.js.map
